// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OutputArea */

.output-area {
  border-radius: 10px;
  border: 1.5px solid #2a2a2a;
  background: #0a0a0a;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 130px;
  transition: border-color 0.2s;
}

/* Empty */
.output-empty {
  align-items: center;
  justify-content: center;
}

.output-empty-text {
  margin: 0;
  color: #555555;
  font-size: 13px;
  text-align: center;
}

/* Error */
.output-error {
  border-color: rgba(224, 85, 85, 0.4);
  background: rgba(224, 85, 85, 0.05);
}

.output-error-text {
  margin: 0;
  color: #ff8a8a;
  font-size: 13px;
  line-height: 1.55;
}

/* Loading */
.output-loading {
  align-items: center;
  justify-content: center;
  gap: 14px;
  border-color: rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.03);
}

.output-spinner {
  display: block;
  width: 30px;
  height: 30px;
  border: 2.5px solid rgba(255, 255, 255, 0.2);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.85s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.output-loading-text {
  margin: 0;
  color: #cccccc;
  font-size: 13px;
}

/* Ready — response visible */
.output-ready {
  border-color: #333333;
  background: linear-gradient(160deg, #0a0a0a 0%, #161616 100%);
}

.output-reply-text {
  margin: 0;
  color: #ffffff;
  font-size: 15px;
  line-height: 1.75;
  font-style: italic;
  word-break: break-word;
  white-space: pre-wrap;
  flex: 1 1;
}

.output-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid #2a2a2a;
}

.btn-copy {
  padding: 9px 20px;
  background: #1a1a1a;
  border: 1.5px solid #333333;
  border-radius: 7px;
  color: #cccccc;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.2px;
}

.btn-copy:hover {
  background: #262626;
  border-color: #ffffff;
  color: #ffffff;
}

.btn-copy:active { transform: scale(0.97); }

.btn-copy.copied {
  background: linear-gradient(135deg, #2a5a3a, #2e6e40);
  border-color: #4caf70;
  color: #88eaa8;
}

/* Mobile */
@media (max-width: 768px) {
  .output-area { padding: 14px 16px; }
  .output-reply-text { font-size: 14px; }
}

/* ── Reply rating row ─────────────────────────────────────────────────── */
.output-rating {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rating-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
}

.rating-btn {
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.78rem;
  cursor: pointer;
  transition: all 0.15s ease;
}

.rating-btn:hover { transform: translateY(-1px); }
.rating-excellent:hover { border-color: #34d399; color: #34d399; }
.rating-good:hover      { border-color: #60a5fa; color: #60a5fa; }
.rating-bad:hover       { border-color: #f87171; color: #f87171; }

.rating-thanks {
  font-size: 0.8rem;
  color: #34d399;
}
`, "",{"version":3,"sources":["webpack://./src/components/OutputArea.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB,sBAAsB,EAAE;;AAE3C;EACE,qDAAqD;EACrD,qBAAqB;EACrB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe,kBAAkB,EAAE;EACnC,qBAAqB,eAAe,EAAE;AACxC;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,oBAAoB,2BAA2B,EAAE;AACjD,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;;AAEjE;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* OutputArea */\n\n.output-area {\n  border-radius: 10px;\n  border: 1.5px solid #2a2a2a;\n  background: #0a0a0a;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 130px;\n  transition: border-color 0.2s;\n}\n\n/* Empty */\n.output-empty {\n  align-items: center;\n  justify-content: center;\n}\n\n.output-empty-text {\n  margin: 0;\n  color: #555555;\n  font-size: 13px;\n  text-align: center;\n}\n\n/* Error */\n.output-error {\n  border-color: rgba(224, 85, 85, 0.4);\n  background: rgba(224, 85, 85, 0.05);\n}\n\n.output-error-text {\n  margin: 0;\n  color: #ff8a8a;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n/* Loading */\n.output-loading {\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  border-color: rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.output-spinner {\n  display: block;\n  width: 30px;\n  height: 30px;\n  border: 2.5px solid rgba(255, 255, 255, 0.2);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.85s linear infinite;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.output-loading-text {\n  margin: 0;\n  color: #cccccc;\n  font-size: 13px;\n}\n\n/* Ready — response visible */\n.output-ready {\n  border-color: #333333;\n  background: linear-gradient(160deg, #0a0a0a 0%, #161616 100%);\n}\n\n.output-reply-text {\n  margin: 0;\n  color: #ffffff;\n  font-size: 15px;\n  line-height: 1.75;\n  font-style: italic;\n  word-break: break-word;\n  white-space: pre-wrap;\n  flex: 1;\n}\n\n.output-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 10px;\n  border-top: 1px solid #2a2a2a;\n}\n\n.btn-copy {\n  padding: 9px 20px;\n  background: #1a1a1a;\n  border: 1.5px solid #333333;\n  border-radius: 7px;\n  color: #cccccc;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.2px;\n}\n\n.btn-copy:hover {\n  background: #262626;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n.btn-copy:active { transform: scale(0.97); }\n\n.btn-copy.copied {\n  background: linear-gradient(135deg, #2a5a3a, #2e6e40);\n  border-color: #4caf70;\n  color: #88eaa8;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .output-area { padding: 14px 16px; }\n  .output-reply-text { font-size: 14px; }\n}\n\n/* ── Reply rating row ─────────────────────────────────────────────────── */\n.output-rating {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rating-label {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.rating-btn {\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: transparent;\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 0.78rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.rating-btn:hover { transform: translateY(-1px); }\n.rating-excellent:hover { border-color: #34d399; color: #34d399; }\n.rating-good:hover      { border-color: #60a5fa; color: #60a5fa; }\n.rating-bad:hover       { border-color: #f87171; color: #f87171; }\n\n.rating-thanks {\n  font-size: 0.8rem;\n  color: #34d399;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
